/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：935
 */

module.exports = {
  screenIndex: "style_screenIndex__L8z7L",
  dropdownImageScreen: "style_dropdownImageScreen__w_DoH"
}
